import { FormattedAuditor } from "../../components/Admin/AuditorListEditor";
import { downloadCSVFile } from "./ReportDownloadCSV";
import moment from "moment";
require('jspdf-autotable');

export const headerRow = [
    "Phone Number",
    "Name",
    "Date Created",
    "Date Last Updated",
    "Status",
    "Person Id",
    "Person Name",
    "Event Id",
    "Event Name",
    "Event Start Date",
    "Event Status",
    "Event Roles",
    "Org Auditors",
    "Org Roles"
];

export async function generateAllTrainerPhoneNumbersReport(formattedAuditors?: FormattedAuditor[] | null) {

    const rows: any[] = [];
    rows.push(headerRow);

    if (!formattedAuditors || formattedAuditors.length === 0) {
        const fileName = "All-Trainer-Phone-Numbers.csv";
        downloadCSVFile(fileName, rows);
        return;
    }

    // Filter auditors that have at least one EventAuditor with a Roles filter
    // where the options include "trainer".
    const trainerAuditors = formattedAuditors.filter((fa) => {
        if (!fa?.auditor?.phoneNumber) return false;
        if (!fa.eventAuditors || fa.eventAuditors.length === 0) return false;

        return fa.eventAuditors.some((eventAuditor) => {
            if (!eventAuditor) return false;
            const filtersObject: any = eventAuditor.filters as any;
            const filtersItems: any[] =
                (filtersObject && Array.isArray(filtersObject.items)
                    ? filtersObject.items
                    : (Array.isArray(eventAuditor.filters) ? (eventAuditor.filters as any[]) : [])) || [];

            if (!filtersItems || filtersItems.length === 0) return false;

            return filtersItems.some((filterItem: any) => {
                if (!filterItem?.filter?.name || !filterItem?.options) return false;
                if (filterItem.filter.name !== "Roles") return false;

                const options: string[] = (filterItem.options as any[])
                    .filter((opt) => typeof opt === "string")
                    .map((opt: any) => (opt as string).toLowerCase());

                return options.includes("trainer");
            });
        });
    });

    // Sort by phone number
    const sortedTrainerAuditors = trainerAuditors.sort((a, b) =>
        (a.auditor.phoneNumber || "").localeCompare(b.auditor.phoneNumber || "")
    );

    // Build CSV rows
    sortedTrainerAuditors.forEach((fa) => {
        const auditor = fa.auditor;

        // Find the first qualifying EventAuditor (with Roles filter including "trainer")
        const qualifyingEventAuditor = fa.eventAuditors.find((eventAuditor) => {
            if (!eventAuditor) return false;
            const filtersObject: any = eventAuditor.filters as any;
            const filtersItems: any[] =
                (filtersObject && Array.isArray(filtersObject.items)
                    ? filtersObject.items
                    : (Array.isArray(eventAuditor.filters) ? (eventAuditor.filters as any[]) : [])) || [];

            if (!filtersItems || filtersItems.length === 0) return false;

            return filtersItems.some((filterItem: any) => {
                if (!filterItem?.filter?.name || !filterItem?.options) return false;
                if (filterItem.filter.name !== "Roles") return false;

                const options: string[] = (filterItem.options as any[])
                    .filter((opt) => typeof opt === "string")
                    .map((opt: any) => (opt as string).toLowerCase());

                return options.includes("trainer");
            });
        });

        const event = qualifyingEventAuditor?.event as any;

        let eventRoles = "";
        if (qualifyingEventAuditor) {
            const filtersObject: any = qualifyingEventAuditor.filters as any;
            const filtersItems: any[] =
                (filtersObject && Array.isArray(filtersObject.items)
                    ? filtersObject.items
                    : (Array.isArray(qualifyingEventAuditor.filters)
                        ? (qualifyingEventAuditor.filters as any[])
                        : [])) || [];

            const rolesFilterItem = filtersItems.find(
                (filterItem: any) => filterItem?.filter?.name === "Roles"
            );

            if (rolesFilterItem?.options && Array.isArray(rolesFilterItem.options)) {
                eventRoles = (rolesFilterItem.options as any[])
                    .filter((opt) => typeof opt === "string")
                    .join(", ");
            }
        }

        // Org auditors name(s)
        const orgAuditorsNames = (fa.organizationAuditors || [])
            .filter((oa) => !!oa)
            .map((oa: any) => oa.organization?.name || "")
            .filter((name: string) => !!name)
            .join("; ");

        // Org roles (from filters on organization auditors, if present)
        const orgRoles: string[] = [];
        (fa.organizationAuditors || []).forEach((oa: any) => {
            const filtersObject: any = oa?.filters as any;
            const filtersItems: any[] =
                (filtersObject && Array.isArray(filtersObject.items)
                    ? filtersObject.items
                    : (Array.isArray(oa?.filters) ? (oa.filters as any[]) : [])) || [];

            filtersItems.forEach((filterItem: any) => {
                if (filterItem?.filter?.name === "Roles" && Array.isArray(filterItem.options)) {
                    const roles = (filterItem.options as any[])
                        .filter((opt) => typeof opt === "string")
                        .join(", ");
                    if (roles) orgRoles.push(roles);
                }
            });
        });

        const orgRolesText = orgRoles.join("; ");

        const personName = `${auditor.person?.firstName || ""} ${auditor.person?.lastName || ""}`.trim();

        const currentRow: any[] = [];
        currentRow.push(auditor.phoneNumber || "");
        currentRow.push(auditor.name || "");
        currentRow.push(auditor.createdOn ? moment(auditor.createdOn).format("MM/DD/YYYY hh:mm:ss a") : "");
        currentRow.push(auditor.updatedOn ? moment(auditor.updatedOn).format("MM/DD/YYYY hh:mm:ss a") : "");
        currentRow.push(auditor.status || "");
        currentRow.push(auditor.personId || "");
        currentRow.push(personName);
        currentRow.push(qualifyingEventAuditor?.eventId || event?.id || "");
        currentRow.push(event?.name || "");
        currentRow.push(event?.startDate || "");
        currentRow.push(qualifyingEventAuditor?.status || "");
        currentRow.push(eventRoles);
        currentRow.push(orgAuditorsNames);
        currentRow.push(orgRolesText);

        rows.push(currentRow);
    });

    const fileName = "All-Trainer-Phone-Numbers.csv";
    downloadCSVFile(fileName, rows);
}
